export default __webpack_public_path__ + "static/media/404_space.5575b521.jpg";